/**
 * Portal home visuals.
 * - portal-hero.jpg: clean lifestyle photo (no baked-in text) for the homepage hero
 * - og-daily-sports-life.jpg: branded share image for WhatsApp / Open Graph
 */
export const PORTAL_HERO_IMAGE = '/portal-hero.jpg';
export const PORTAL_SHARE_IMAGE = '/og-daily-sports-life.jpg';

/**
 * @deprecated Decorative side images; replaced by branded full-bleed hero.
 */
export const PORTAL_BACKGROUND_IMAGES = {
  kick: PORTAL_HERO_IMAGE,
  running: PORTAL_HERO_IMAGE,
};
